const menuItems = [
  {
    url: "/",
    name: "Home",
  },
  {
    url: "/section/world",
    name: "World",
  },
  {
    url: "/section/business",
    name: "Business",
  },
  {
    url: "/section/politics",
    name: "Politics",
  },
  {
    url: "/section/us",
    name: "U.S.",
  },
  {
    url: "/section/sports",
    name: "Sports",
  },
  {
    url: "/section/health",
    name: "Health",
  },
  {
    url: "/section/nyregion",
    name: "N.Y.",
  },
  {
    url: "/section/opinion",
    name: "Opinion",
  },
  {
    url: "/section/technology",
    name: "Tech",
  },
  {
    url: "/section/science",
    name: "Science",
  },
  {
    url: "/section/arts",
    name: "Arts",
  },
  {
    url: "/section/style",
    name: "Style",
  },
  {
    url: "/section/travel",
    name: "Travel",
  },
  {
    url: "/section/magazine",
    name: "Magazine",
  },
  {
    url: "/section/t-magazine",
    name: "T Magazine",
  },
  {
    url: "/section/realestate",
    name: "Real Estate",
  },
  {
    url: "/section/obituaries",
    name: "Obituaris",
  },
  {
    url: "/section/graphics",
    name: "Graphics",
  },
  {
    url: "/section/upshot",
    name: "The Upshot",
  },
];

export default menuItems;